import { Button, Form, Input} from 'antd';
import React from "react";
import CrmModal from "../../../components/CrmModal";
import { useMutation } from '@apollo/client';
import { UPDATE_CLIENT } from '../../../graphql/client';
import { UPDATE_PARENT } from '../../../graphql/parent';
import { PlusOutlined } from '@ant-design/icons';
import _ from 'lodash';

export default function ModalAddSkill({ isOpen, onClose, onUpdate, client, type }) {

    const [updateMutation, { loading }] = useMutation(type === 'child' ? UPDATE_CLIENT : UPDATE_PARENT);
    const [form] = Form.useForm();

    const onFinish = async (data) => {

        const skills = _.map(client?.attributes?.skill, item => ({id: item.id}));
        skills.push({
            name: data.name,
            own: false,
        });
        await updateMutation({
            variables: {
                id: client.id,
                data: {
                    skill: skills,
                }
            },
            onCompleted: () => {
                form.resetFields();
                onUpdate();
                onClose();
            }
        })
    };

    return (
        <CrmModal isOpen={isOpen} onClose={onClose} title={'Добавить навык'}>
            <div className={'modal-basic-form'}>

                <Form size={'large'} layout={'vertical'} onFinish={onFinish} disabled={loading}>
                    <Form.Item
                        name={'name'}
                        label={'Название навыка'}
                        rules={[{ required: true, message: 'Заполните, пожалуйста' }]}
                    >
                        <Input placeholder={'Умение прыгать...'} />
                    </Form.Item>
                    <Form.Item>
                        <Button loading={loading} htmlType={'submit'} type={'primary'} icon={<PlusOutlined />}>
                            Добавить
                        </Button>
                    </Form.Item>
                </Form>

            </div>
        </CrmModal>
    )

}